import { DownloadListComponent } from './download-list/download-list.component';
export var downloadRoutes = [
    {
        path: 'download',
        component: DownloadListComponent
    }
];
var DownloadRoutingModule = (function () {
    function DownloadRoutingModule() {
    }
    return DownloadRoutingModule;
}());
export { DownloadRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-routing.module.ts.pre-build-optimizer.js